import { last } from 'lodash-es';

export const getPopperContainer = (): HTMLElement => {
  return (
    last(
      document.querySelectorAll('[data-testid="dialog"][data-active="true"]'),
    ) ??
    document.querySelector('#root') ??
    document.body
  );
};
